import { baseApi } from "./baseApi";
import { InvoiceResponse } from "../models/api/invoice/invoiceResponse";
import { AdminInvoiceResponse } from "../models/api/invoice/adminInvoiceResponse";
import { AdminInvoicesQueryParams } from "../models/api/invoice/adminInvoicesQueryParams";
import { PaginatedList } from "../models/api/paginatedList";

import { InvoiceUploadRequest } from "../models/api/invoice/invoiceUploadRequest";
import { InvoiceUpdateRequest } from "../models/api/invoice/invoiceUpdateRequest";

export const invoicesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserInvoices: builder.query<InvoiceResponse[], void>({
            query: () => ({
                url: `${import.meta.env.VITE_INVOICES}/user`,
            }),
            providesTags: ["invoices"],
        }),
        getAllInvoices: builder.query<PaginatedList<AdminInvoiceResponse>, AdminInvoicesQueryParams>({
            query: ({ pageNumber, pageSize, search, status, sortBy, sortOrder }) => ({
                url: `${import.meta.env.VITE_INVOICES}/all`,
                params: {
                    pageNumber,
                    pageSize,
                    ...(search && { search }),
                    ...(status !== undefined && { status }),
                    ...(sortBy && { sortBy }),
                    ...(sortOrder && { sortOrder }),
                },
            }),
            providesTags: ["invoices"],
        }),
        getOrderInvoices: builder.query<InvoiceResponse[], string>({
            query: (orderNumber) => ({
                url: `${import.meta.env.VITE_INVOICES}/order/${orderNumber}`,
            }),
            providesTags: ["invoices"],
        }),
        uploadInvoice: builder.mutation<InvoiceResponse, InvoiceUploadRequest>({
            query: ({ file, ...params }) => {
                const formData = new FormData();
                formData.append("file", file);
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        formData.append(key, value.toString());
                    }
                });
                return {
                    url: `${import.meta.env.VITE_INVOICES}/upload`,
                    method: "POST",
                    body: formData,
                };
            },
            invalidatesTags: ["invoices"],
        }),
        updateInvoice: builder.mutation<void, { id: string; body: InvoiceUpdateRequest }>({
            query: ({ id, body }) => ({
                url: `${import.meta.env.VITE_INVOICES}/${id}`,
                method: "PUT",
                body: { id, ...body },
            }),
            invalidatesTags: ["invoices"],
        }),
        deleteInvoice: builder.mutation<void, string>({
            query: (id) => ({
                url: `${import.meta.env.VITE_INVOICES}/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["invoices"],
        }),
    }),
});

export const {
    useGetUserInvoicesQuery,
    useGetAllInvoicesQuery,
    useGetOrderInvoicesQuery,
    useUploadInvoiceMutation,
    useUpdateInvoiceMutation,
    useDeleteInvoiceMutation,
} = invoicesApi;
